import { Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { Avatar, AvatarGroup } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { Emoji, Picker } from 'emoji-mart';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { API } from 'src/api';
import { useWorkspaceService } from 'src/api/services/workspaces/workspace';

export interface WorkspaceNavbarProps {
  isSideBarOpen?: boolean;

  wrapperClassName?: string;
}

export const WorkspaceNavbar = ({
  wrapperClassName,
  isSideBarOpen,
}: WorkspaceNavbarProps): JSX.Element => {
  const router = useRouter();

  const { useWorkspaces } = useWorkspaceService();
  const { userWorkspaces: workspaces, revalidate: worksSpaceRevalidate } = useWorkspaces({});
  const [activeWorkspaceIndex, setActiveWorkspaceIndex] = useState<number>(0);

  const wrapperClasses = classNames({
    'flex w-full border-b justify-between border-gray-200 bg-white p-22 z-40 block': true,
    [wrapperClassName || '']: !!wrapperClassName,
  });

  useEffect(() => {
    workspaces?.map(
      (item, index) =>
        item.workspaceId === router.query.workspaceId && setActiveWorkspaceIndex(index)
    );
  }, [router.query, workspaces]);

  return (
    <nav className={wrapperClasses}>
      <div className="font-medium text-gray-999 flex ">
        <Popover enabled={false} offset={[0, -60]}>
          <PopoverTrigger>
            <button disabled className="">
              <Emoji
                emoji={
                  workspaces[activeWorkspaceIndex]?.icon || {
                    id: 'file_folder',
                  }
                }
                set="apple"
                size={18}
              />
              &nbsp;
            </button>
          </PopoverTrigger>
          <PopoverContent>
            <EmojiPicker workspaceId={workspaces[activeWorkspaceIndex]?.workspaceId} />
          </PopoverContent>
        </Popover>
        <span className="block mt-2">{workspaces[activeWorkspaceIndex]?.name}</span>
      </div>

      {/* <div className="flex">
        {workspaces[activeWorkspaceIndex]?.members.length &&
        workspaces[activeWorkspaceIndex]?.members?.length > 0 ? (
          <div className="flex mt-2 mr-8">
            <AvatarGroup maxCount={4} className="mr-13">
              {workspaces[activeWorkspaceIndex]?.members?.map((memberInfo, index) => (
                <Avatar
                  key={`${memberInfo.member?.firstname}-${index}`}
                  name={memberInfo.member?.firstname}
                  type={memberInfo.member?.avatar ? 'photo' : 'initials'}
                  src={memberInfo.member?.avatar}
                  wrapperClassName="-ml-8 border-2 border-white  transform transition duration-500 hover:scale-125"
                />
              ))}
            </AvatarGroup>
            {workspaces[activeWorkspaceIndex]?.members?.length > 4 && (
              <Avatar
                name={workspaces[activeWorkspaceIndex]?.members?.length - 4}
                tooltip={false}
                type={'initials'}
                src={''}
                wrapperClassName="-ml-18 border-white border-1 transform transition duration-500 hover:scale-125"
              />
            )}
          </div>
        ) : null}
      </div> */}
    </nav>
  );
};
const EmojiPicker = ({ workspaceId }: { workspaceId: string }) => {
  const { useWorkspaces } = useWorkspaceService();
  const { userWorkspaces: workspaces, revalidate: worksSpaceRevalidate } = useWorkspaces({});
  const handleUpdateEmoji = async ({ icon }: { icon: any }) => {
    const response = await API.put(`/workspace`, { workspaceId: workspaceId, icon: icon });
    if (response) {
      worksSpaceRevalidate();
    }
  };

  return (
    <div
      className="rounded-lg w-304 bg-white overflow-y-auto mt-64 ml-32 pt-10"
      style={{ boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)', maxHeight: '80vh' }}
    >
      <div className="border-b border-gray-200 flex justify-between pr-12">
        <div className="border-b border-primary-500 text-primary-500 text-sm pt-12 ml-20 pb-10">
          Emoji
        </div>
        <button
          className="text-gray-500 font-semibold text-sm pt-12 ml-20 pb-10"
          onClick={() => handleUpdateEmoji({ icon: { id: '' } })}
        >
          Remove
        </button>
      </div>
      <div className="flex justify-center my-16 mx-12">
        <Picker
          title="Pick your emoji…"
          emoji="point_up"
          sheetSize={32}
          perLine={9}
          showPreview={false}
          showSkinTones={false}
          onSelect={(e) => handleUpdateEmoji({ icon: { id: e.id } })}
        />
      </div>
    </div>
  );
};
